import { GetterTree } from "vuex";
import { RootState, UserState } from "@/interface";
import {
  isDevGetter,
  canEnterClassGetter,
  isUserBlockedGetter
} from "./getter-types";
import { isDev, isQA, isBlocked } from "@/helper/userHelper";
import { canEnterClass } from "@/helper/homeHelpe";

export const getters: GetterTree<UserState, RootState> = {
  [isDevGetter]: (state: UserState): boolean => {
    return isDev(state.rol);
  },
  [canEnterClassGetter]: (state: UserState) => (date?: string) => {
    if (isBlocked(state.rol)) {
      return false;
    }
    if (isQA(state.rol)) {
      return true;
    }
    return canEnterClass(date);
  },
  [isUserBlockedGetter]: (state: UserState): boolean => {
    return isBlocked(state.rol);
  }
};
